import React from "react";
import { AlertTriangle } from "lucide-react";

export function DisclaimerBanner({ compact = false }) {
  if (compact) {
    return (
      <div data-testid="disclaimer-compact" className="flex items-center gap-2 text-xs text-amber-400/90 bg-amber-500/10 border border-amber-500/20 rounded-lg px-3 py-2">
        <AlertTriangle className="w-4 h-4 shrink-0" />
        <span>Virtual money — educational simulation only. Real trading risks capital loss.</span>
      </div>
    );
  }
  return (
    <div data-testid="disclaimer-banner" className="flex items-start gap-3 text-sm text-amber-300 bg-amber-500/10 border border-amber-500/25 rounded-xl px-4 py-3">
      <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5" />
      <p className="leading-relaxed">
        <span className="font-semibold text-amber-200">Educational platform only.</span> All trading here uses <span className="font-semibold">$100,000 in virtual paper money</span>. No real money can be traded and no profits can be earned. Trading real financial markets carries a high risk of losing money.
      </p>
    </div>
  );
}

export default DisclaimerBanner;
